export function Logo({ className = "", showText = true }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative h-8 w-8">
        <div className="absolute inset-0 rounded-md bg-primary" />
        <div className="absolute inset-[3px] rounded-[3px] bg-background" />
        <div className="absolute inset-[6px] rounded-[2px] bg-primary" />
      </div>
      {showText && (
        <span className="font-display text-xl font-bold tracking-tight">Noteology</span>
      )}
    </div>
  );
}
